import gql from 'graphql-tag'

export const QUERY_GET_CURRENT_YEAR = gql`
  query currentYear ($currentDate: timestamptz) {
    currentYear: calendar_date_range (
      where: {
        term: { _eq: YEAR },
        start_date: { _lte: $currentDate },
        end_date: { _gte: $currentDate }
      }
    ) {
      id
      name
      year
      start: start_date
      end: end_date
    }
  }
`

export const QUERY_GET_ROLES = gql`
  query getRole {
    role (
      order_by : { id: asc }
    ) {
      id
      name
    }
  }
`

export const QUERY_GET_LOCATIONS = gql`
  query getLocation {
    location {
      id
      name
    }
  }
`

export const QUERY_GET_LEVELS = gql`
  query getLevel {
    level {
      id
      name
    }
  }
`

export const QUERY_GET_SUBJECTS = gql`
  query getSubject {
    subject {
      id
      name
    }
  }
`
